import { render, staticRenderFns } from "./Genero.vue?vue&type=template&id=1591151a&scoped=true&"
import script from "./Genero.vue?vue&type=script&lang=js&"
export * from "./Genero.vue?vue&type=script&lang=js&"
import style0 from "./Genero.vue?vue&type=style&index=0&id=1591151a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1591151a",
  null
  
)

export default component.exports